import { Controller } from "@hotwired/stimulus"
import { reducedMotion } from "~/lib/motion"

// Counts a number up from 0 the first time it scrolls into view.
// The server renders the final value, so it's correct without JS.
//   <dd data-controller="counter" data-counter-to-value="807">807</dd>
export default class extends Controller {
  static values = { to: Number, decimals: { type: Number, default: 0 }, suffix: String }

  connect() {
    if (reducedMotion) return
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      this.observer.disconnect()
      this.run()
    }, { threshold: 0.6 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  run() {
    const start = performance.now(), duration = 1400
    const frame = (now) => {
      const k = Math.min(1, (now - start) / duration)
      this.element.textContent = this.format(this.toValue * (1 - (1 - k) ** 3))
      if (k < 1) requestAnimationFrame(frame)
    }
    requestAnimationFrame(frame)
  }

  format(value) {
    const number = value.toLocaleString("en-US", { minimumFractionDigits: this.decimalsValue, maximumFractionDigits: this.decimalsValue })
    return number + this.suffixValue
  }
}
